"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions);
    },
})(legacy_1.action('saveSurfaceActionsOption')(function saveSurfaceActionsOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.readSurfaceActions = owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceActions, userOptions.readSurfaceActions);
                    userOptions.readSurfaceAddins = owa_options_core_1.getFallbackValueIfNull(optionState.readSurfaceAddins, userOptions.readSurfaceAddins);
                    userOptions.composeSurfaceActions = owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceActions, userOptions.composeSurfaceActions);
                    userOptions.composeSurfaceAddins = owa_options_core_1.getFallbackValueIfNull(optionState.composeSurfaceAddins, userOptions.composeSurfaceAddins);
                    return [4 /*yield*/, owa_outlook_service_options_1.lazyCreateOrUpdateOptionsForFeature.importAndExecute(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSurfaceActionsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/actions/saveSurfaceActionsOption.js
// module id = 3760
// module chunks = 2